import { render, staticRenderFns } from "./ignore_button.vue?vue&type=template&id=76b007aa&"
import script from "./ignore_button.vue?vue&type=script&lang=js&"
export * from "./ignore_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b007aa')) {
      api.createRecord('76b007aa', component.options)
    } else {
      api.reload('76b007aa', component.options)
    }
    module.hot.accept("./ignore_button.vue?vue&type=template&id=76b007aa&", function () {
      api.rerender('76b007aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/conflicts/ignore_button.vue"
export default component.exports